const currencies = {
  EUR: "€",
  GBP: "£",
  AUD: "AU$",
  USD: "$",
};

// https://shopify.dev/docs/themes/liquid/reference/objects/country-option-tags
// https://shopify.dev/docs/themes/files/customers-addresses-liquid
new Shopify.CountryProvinceSelector(
  "shippingCountrySelect",
  "shippingProvinceSelect",
  {
    hideElement: "shippingProvinceSelect",
  }
);

function getPriceDisplay(rate) {
  if (Number(rate.price) === 0) {
    return "<strong>Free!</strong>";
  } else {
    return `<strong>${currencies[rate.currency]}${rate.price}</strong>`;
  }
}

document.getElementById("shippingCalculate").addEventListener("click", () => {
  const country = document.getElementById("shippingCountrySelect").value;
  const province = document.getElementById("shippingProvinceSelect").value;
  const zip = document.getElementById("shippingZipCode").value.toUpperCase();

  fetch(
    `/cart/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
  )
    .then((response) => response.json())
    .then((data) => {
      const shippingPrice = document.getElementById("shippingPrice");

      console.log(data);
      if (data.error) {
        const [error] = data.error;
        shippingPrice.innerHTML = error;
        console.error(JSON.stringify(data));
        dataLayer.push({
          event: "shippingCalculate",
          error: JSON.stringify(data),
        });
        return;
      }

      if (data.zip) {
        shippingPrice.innerHTML = `Please enter a valid postal code.`;
        console.error(JSON.stringify(data));
        dataLayer.push({
          event: "shippingCalculate",
          error: JSON.stringify(data),
        });
        return;
      }

      const { shipping_rates } = data;

      dataLayer.push({ event: "shippingCalculate", country });

      shippingPrice.innerHTML = `Estimated shipping fee:<br/> ${shipping_rates
        .map((rate) => `${rate.name} - ${getPriceDisplay(rate)}<br/>`)
        .join("")}`;
    })
    .catch((e) => {
      dataLayer.push({ event: "shippingCalculate", error: e.message });
      console.error(e);
    });
});
